module.exports = global["_"] = require("-!.\\underscore.js");